import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans } from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import AddFilter from "./AddFilter";
import axios, { reportClient } from "../../../AxiosClient";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Divider from "@material-ui/core/Divider";
import InternalFilters from "./InternalFilters";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});
export class ChartStepTwo extends Component {
  state = {
    requestTokenMethod: "Parameters",
    object: false,
    currentKeys: [],
    arrayLocations: [],
    currentLocation: [],
    query: {},
    dataUrl: "",
    dataFilters: [],
    loading: false,
  };
  render() {
    const { classes, ...withoutClasses } = this.props;
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            marginRight: 8,
          }}
        >
          {this.props.authentication.radioChoice === "External" ? (
            <>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  fullWidth
                  onChange={(e) => this.props.setDataUrl(e.target.value)}
                  label={this.props.t("report_external_url")}
                  value={this.props.dataUrl}
                  defaultValue="https://"
                />
              </FormControl>

              <FormControl component="fieldset" className={classes.formControl}>
                <div>
                  {this.state.dataFilters.map((filter) => (
                    <Chip
                      style={{ margin: 2 }}
                      label={filter.filterName + ": " + filter.filterValue}
                    />
                  ))}
                </div>
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <AddFilter
                  handleAddFilter={(filter) =>
                    this.setState(
                      {
                        dataFilters: [...this.state.dataFilters, filter],
                      },
                      () => {
                        this.props.onFilterUpdate(this.state.dataFilters);
                      }
                    )
                  }
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <Button onClick={this.handleQuery} color="primary" autoFocus>
                  {this.props.t("report_get_data_button")}
                </Button>
              </FormControl>
            </>
          ) : (
            <InternalFilters onFilterChange={this.onFilterChange} />
          )}
        </div>
        <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
          <Divider orientation="vertical" />
          <div
            style={{
              marginLeft: 8,
              width: "100%",
              maxHeight: 300,
              overflowY: "auto",
            }}
          >
            {this.state.loading ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                {this.state.object && (
                  <>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <Breadcrumbs aria-label="breadcrumb">
                        <Link
                          color="inherit"
                          href="#"
                          onClick={() => this.changeLocation("home")}
                        >
                          {this.props.t("report_breadcrumb_home")}
                        </Link>
                        {this.state.currentLocation.map((location) => (
                          <Link
                            color="inherit"
                            href="#"
                            onClick={() => this.changeLocation(location)}
                          >
                            {location}
                          </Link>
                        ))}
                      </Breadcrumbs>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                      style={{ display: "flex" }}
                    >
                      <Table className={classes.table}>
                        <TableHead>
                          <TableRow>{this.getChoiceHeader()}</TableRow>
                        </TableHead>
                      </Table>
                    </FormControl>
                  </>
                )}
                {this.props.array &&
                !this.state.object &&
                this.props.array.length > 0 ? (
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    style={{ display: "flex" }}
                  >
                    <Table className={classes.table} id="report-data-table">
                      <TableHead>
                        <TableRow>{this.getHeader()}</TableRow>
                      </TableHead>
                      <TableBody>{this.getRowsData()}</TableBody>
                    </Table>
                  </FormControl>
                ) : (
                  <>{this.props.t("report_no_data_cannot_define")}</>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  onFilterChange = (query) => {
    this.getKeys([]);
    this.setState({ query }, this.handleQuery);
    this.props.onQueryUpdate(query);
  };

  getKeys = (data) => {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        this.props.handleKeyChange(Object.keys(data[0]));
      } else {
        this.props.handleKeyChange([]);
        this.props.handleDataChange([]);
      }
    } else if (data instanceof Object) {
      this.findKeys(data, this.props.dataBreadcrumbs);
    }
  };
  changeLocation = (location) => {
    if (location === "home") {
      this.setState({ currentLocation: [] });
      this.props.setDataBreadcrumbs([]);
      this.findKeys(this.props.originalData, []);
    } else {
      let cloneCurrentLocation = JSON.parse(
        JSON.stringify(this.state.currentLocation)
      );
      let cloneDataBreadcrumbs = JSON.parse(
        JSON.stringify(this.props.dataBreadcrumbs)
      );
      cloneCurrentLocation = cloneCurrentLocation.splice(
        0,
        cloneCurrentLocation.indexOf(location) + 1
      );
      cloneDataBreadcrumbs = cloneDataBreadcrumbs.splice(
        0,
        cloneCurrentLocation.indexOf(location) + 1
      );
      this.setState({ currentLocation: cloneCurrentLocation });
      this.props.setDataBreadcrumbs(cloneDataBreadcrumbs);
      this.findKeys(this.state.originalData, cloneDataBreadcrumbs);
    }
  };
  includesArray = (location) => {
    let check = false;
    this.state.arrayLocations.map((locations) => {
      check = location.every((i) => locations.includes(i));
      if (check) {
        return true;
      }
    });
    return check;
  };
  findKeys = (data, dataBreadcrumbs) => {
    let currentData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < dataBreadcrumbs.length; i++) {
      currentData = currentData[dataBreadcrumbs[i].value];
    }
    if (currentData instanceof Object) {
      let keys = Object.keys(currentData);
      let currentKeys = [];
      keys.map((key) => {
        let newKey = {};
        if (Array.isArray(currentData[key])) {
          newKey.type = "array";
        } else if (currentData[key] instanceof Object) {
          newKey.type = "object";
        } else {
          newKey.type = "other";
        }
        newKey.value = key;
        currentKeys.push(newKey);
      });
      this.setState({ currentKeys });
    }
  };
  getChoiceHeader = () => {
    var keys = this.state.currentKeys;
    if (Array.isArray(keys)) {
      return keys.map((key, index) => {
        let hasLocation = this.includesArray([
          ...this.state.currentLocation,
          key.value,
        ]);
        return (
          <TableCell key={key}>
            {" "}
            <Button
              disabled={key.type === "other" || !hasLocation}
              onClick={() => this.selectDataHeader(key)}
              color="primary"
              autoFocus
            >
              {key.value.toUpperCase()}
            </Button>
          </TableCell>
        );
      });
    }
  };
  selectDataHeader = (arrayName) => {
    let currentData = JSON.parse(JSON.stringify(this.props.originalData));
    let dataBreadcrumbs = [...this.props.dataBreadcrumbs, arrayName];
    for (let i = 0; i < dataBreadcrumbs.length; i++) {
      currentData = currentData[dataBreadcrumbs[i].value];
    }
    if (Array.isArray(currentData)) {
      this.setState({ object: false });
      this.props.handleArrayChange(currentData);
      this.props.handleChartChange({
        ...this.props.chart,
        data: currentData,
        dataBreadcrumbs: dataBreadcrumbs,
      });
      this.props.setDataBreadcrumbs(dataBreadcrumbs);
      this.getKeys(currentData);
    } else {
      this.setState({
        currentLocation: [...this.state.currentLocation, arrayName.value],
      });
      this.props.handleChartChange({
        ...this.props.chart,
        dataBreadcrumbs: dataBreadcrumbs,
      });
      this.props.setDataBreadcrumbs(dataBreadcrumbs);
      this.findKeys(this.props.originalData, [
        ...this.props.dataBreadcrumbs,
        arrayName,
      ]);
    }
  };
  getHeader = () => {
    var keys = this.props.keys;
    if (Array.isArray(keys)) {
      return keys.map((key, index) => {
        return (
          <TableCell key={key}>
            {this.props.t("report_column_" + key).toUpperCase()}
          </TableCell>
        );
      });
    }
  };
  renderRow = (props) => {
    return props.keys.map((key, idx) => {
      let renderData;
      props.data[key] instanceof Object
        ? (renderData = JSON.stringify(props.data[key]))
        : (renderData = props.data[key]);
      return <TableCell key={idx}>{renderData}</TableCell>;
    });
  };
  getRowsData = () => {
    var items = this.props.array;
    var keys = this.props.keys;
    return items.map((row, index) => {
      return (
        <TableRow key={index}>
          {this.renderRow({ key: index, data: row, keys: keys })}
        </TableRow>
      );
    });
  };
  findArrays = (data, location) => {
    let keys = Object.keys(data);
    let currentData = JSON.parse(JSON.stringify(data));
    let newLocation = JSON.parse(JSON.stringify(location));
    for (let i = 0; i < keys.length; i++) {
      if (Array.isArray(currentData[keys[i]])) {
        newLocation.push(keys[i]);
        this.setState({
          arrayLocations: [...this.state.arrayLocations, newLocation],
        });
      } else if (currentData[keys[i]] instanceof Object) {
        newLocation.push(keys[i]);
        this.findArrays(currentData[keys[i]], newLocation);
      }
    }
  };
  handleQuery = () => {
    let config = {
      // headers: { "Access-Control-Allow-Origin": "*" },
    };
    this.setState({ loading: true });
    if (this.props.authentication.radioChoice === "Internal") {
      reportClient({
        url: "/graphql",
        method: "post",
        data: this.state.query,
      })
        .then((res) => {
          // if (!Array.isArray(res.data)) {
          //   this.setState({ object: true });
          //   this.props.handleDataChange(res.data);
          //   this.props.handleOriginalDataChange(res.data);
          //   this.findArrays(res.data, []);
          //   this.getKeys(res.data);
          // } else {
          //   this.getKeys(res.data);
          //   this.props.handleDataChange(res.data);
          //   this.props.handleArrayChange(res.data);
          // }

          this.setState({ loading: false });
          let keyName = Object.keys(res.data.data)[0];
          let dataArray = res.data.data[keyName];
          // let breadCrumbArray = []
          // breadCrumbArray.push(keyName)
          // this.props.setDataBreadcrumbs(breadCrumbArray)
          if (Array.isArray(dataArray)) {
            this.getKeys(dataArray);
            this.props.handleDataChange(dataArray);
            this.props.handleArrayChange(dataArray);
            this.props.handleChartChange({
              ...this.props.chart,
              data: dataArray,
              // dataBreadcrumbs: breadCrumbArray,
            });
          }
        })
        .catch(() => {
          this.setState({ loading: false });
        });
      return;
    }
    let parameters = "?";
    if (this.props.authentication.authMethod === "OAuth") {
      config = {
        ...config,
        headers: { Authorization: `Bearer ${this.state.token}` },
      };
      if (this.props.authentication.requestTokenMethod === "Parameters") {
        parameters = `${parameters}access_token=${this.props.token}&state=${
          this.props.authentication.state
        }&response_type=code&`;
      }
    }
    if (this.props.authentication.authMethod === "ApiKey") {
      if (this.props.authentication.apiKeyMethod === "Parameter") {
        parameters = `${parameters}${
          this.props.authentication.apiKeyParamName
        }=${this.props.authentication.apiKeyValue}&`;
      }
    }
    let body = {};
    if (this.props.authentication.radioDataSendMethodChange === "Parameters") {
      this.props.chart.dataFilters.map(
        (filter) =>
          (parameters =
            parameters + filter.filterName + "=" + filter.filterValue + "&")
      );
    } else {
      this.props.chart.dataFilters.map(
        (filter) => (body[filter.filterName] = filter.filterValue)
      );
    }
    axios
      .get(this.props.dataUrl + parameters, body, config)
      .then((res) => {
        this.setState({ loading: false });
        if (!Array.isArray(res.data)) {
          this.setState({ object: true });
          this.props.handleDataChange(res.data);
          this.props.handleOriginalDataChange(res.data);
          this.findArrays(res.data, []);
          this.getKeys(res.data);
        } else {
          this.getKeys(res.data);
          this.props.handleDataChange(res.data);
          this.props.handleArrayChange(res.data);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
}
export default withTranslation()(withStyles(styles)(ChartStepTwo));
